import { render } from "./InstallBanner.vue?vue&type=template&id=469c06c2&scoped=true&ts=true&lang=pug"
import script from "./InstallBanner.vue?vue&type=script&lang=ts"
export * from "./InstallBanner.vue?vue&type=script&lang=ts"

import "./InstallBanner.vue?vue&type=style&index=0&id=469c06c2&scoped=true&lang=css"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/PWA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469c06c2"]])

export default __exports__